import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import auth from '../token';
Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  const role = localStorage.getItem('role');
  if (to.fullPath !== '/' 
      && to.fullPath !== '/login' 
      && to.fullPath !== '/restore'
    ) {
    if (to.matched.some(record => record.meta.requiresAuth) || !role) {
      swal('¡Algo salio mal!', 'No autorizado', 'warning');
      setTimeout(() => {
        auth.logout();
      }, 2000)
    } else {
      next();
    }
  } else {
    next();
  }

})

export default router;
